import client from '../httpClient';

// user: /users/:id ユーザー更新
const userUpdateApi = (userId, modifyObj) => {
  const UPDATE_USER_URL = `/users/${String(userId)}`;
  return client.put(UPDATE_USER_URL, JSON.stringify(modifyObj), { isShowMessage: true });
};

export default userUpdateApi;
